export default "__VITE_ASSET__DHIISNCB__"